import { Dispatch, SetStateAction, useEffect } from 'react'

import { useToast } from '@chakra-ui/react'
import { useChainModal, useConnectModal } from '@rainbow-me/rainbowkit'
import { avalanche, avalancheFuji } from 'viem/chains'
import { useAccount, useWaitForTransactionReceipt } from 'wagmi'

import { useApproveGGPtoVault } from '@/hooks/approve'

export interface ApproveProps {
  amount: bigint
  balance: bigint
  setApproveStatus: Dispatch<SetStateAction<'error' | 'loading' | 'success' | 'idle'>>
}

const ApproveButton = ({ amount, balance, setApproveStatus }: ApproveProps) => {
  const { isConnected, chain } = useAccount()
  const { openConnectModal } = useConnectModal()
  const { openChainModal } = useChainModal()
  const toast = useToast()
  const {
    simulation,
    isPending: isApproveLoading,
    writeContract: approve,
    hash,
  } = useApproveGGPtoVault(amount)

  const {
    isLoading,
    isSuccess,
    data: receipt,
    isError,
  } = useWaitForTransactionReceipt({
    hash,
  })

  useEffect(() => {
    if (isSuccess && receipt) {
      if (receipt.success === 1) {
        setApproveStatus('success')
        toast({
          position: 'top',
          title: 'Amount Approved',
          status: 'info',
          duration: 8000,
          description: <span>Please proceed to deposit.</span>,
        })
      } else if (receipt.status === 0) {
        setApproveStatus('error')
      }
    } else if (isError) {
      setApproveStatus('error')
    }
  }, [isSuccess, receipt, isError, toast, setApproveStatus])

  if (!chain) {
    return (
      <button className="rng-btn rng-btn--ink" onClick={openChainModal} type="button">
        Wrong network
      </button>
    )
  }

  if (chain.id != avalanche.id && chain.id != avalancheFuji.id) {
    return (
      <button className="rng-btn rng-btn--ink" onClick={openChainModal} type="button">
        Wrong network
      </button>
    )
  }

  if (amount > balance) {
    return (
      <button className="rng-btn rng-btn--ink" disabled type="button">
        Insufficient balance
      </button>
    )
  }

  return isConnected ? (
    <button
      className="rng-btn rng-btn--ink"
      disabled={!amount || amount <= 0 || isApproveLoading || !approve || isLoading}
      onClick={() => approve(simulation.data.request)}
      type="button"
    >
      {isLoading || isApproveLoading ? 'Approving…' : 'Approve...'}
    </button>
  ) : (
    <button
      className="rng-btn rng-btn--ink"
      data-testid="connect"
      onClick={openConnectModal}
      type="button"
    >
      Connect Wallet
    </button>
  )
}

export default ApproveButton
